export enum ParentPageEvents {

  PARENTS_APP_ACCESSED= "parents_app_accessed",
  
  //photo
  PARENTS_APP_HOME_PAGE_NEXT_ICON_CLICKED = "parents_app_home_page_next_icon_clicked",
  PARENTS_APP_HOME_PAGE_BACK_ICON_CLICKED = "parents_app_home_page_back_icon_clicked",

  //notice
  PARENTS_APP_HOME_PAGE_NOTICE_CLICKED = "parents_app_home_page_view_notice_clicked",
  PARENTS_APP_HOME_PAGE_DOCUMENT_CLICKED = "parents_app_home_page_document_clicked",
  PARENTS_APP_NOTICE_PAGE_BACK_ICON_CLICKED = "parents_app_notice_page_back_icon_clicked",

  //result
  PARENTS_APP_HOME_PAGE_RESULT_CLICKED = "parents_app_home_page_result_clicked",
  PARENTS_APP_RESULT_PAGE_LOGIN_SUCCESS = "parents_app_result_page_login_success",
  PARENTS_APP_RESULT_PAGE_NAME_CLICKED = "parents_app_result_page_name_clicked",
  PARENTS_APP_RESULT_PAGE_SUBJECT_CLICKED = "parents_app_result_page_subject_clicked",
  PARENTS_APP_RESULT_PAGE_TEST_NAME_CLICKED = "parents_app_result_page_test_name_clicked",

  //diary
  PARENTS_APP_HOME_PAGE_DIARY_CLICKED = "parents_app_home_page_diary_clicked",
  PARENTS_APP_DIARY_PAGE_CLASSWORK_CLICKED = "parents_app_diary_page_classwork_clicked",
  PARENTS_DIARY_DATE_CLICKED = "parents_diary_date_clicked",
  PARENTS_APP_DIARY_NAME_CLICKED = "parents_app_diary_name_clicked",
  PARENTS_APP_DIARY_PAGE_HOMEWORK_CLICKED = "parents_app_diary_page_homework_clicked",

  //doubts
  PARENTS_APP_HOME_PAGE_TEST_CLICKED = "parents_app_home_page_test_clicked",
  PARENTS_APP_DOUBTS_SEND_CLICKED = "parents_app_doubts_send_clicked",

  //Study
  PARENTS_APP_STUDY_NAME_CLICKED="parent_app_study_section_clicked",

  //Test
    PARENT_APP_TEST_SECTION_CLICKED = "parents_app_test_section_clicked",
    TEST_PAGE_VIEW_REPORT_CLICKED = "parent_app_test_page_view_report_clicked",
    TEST_PAGE_VIEW_RESPONSE_CLICKED = "parent_app_test_page_view_response_clicked",
    TEST_PAGE_TAKE_TEST_CLICKED = "parent_app_test_page_take_test_clicked",
    TEST_PAGE_START_TEST_TYPE_ANSWER_CLICKED = "parent_app_test_page_start_test_type_your_answer_clicked",
    TEST_PAGE_START_TEST_UPLOAD_ANSWER_SHEET_CLICKED = "parent_app_test_page_start_test_upload_answer_sheet_clicked",
    TEST_PAGE_START_TEST_ANSWER_TYPES = "parents_app_test_page_start_test_answer_types",
    TEST_PAGE_START_TEST_SUBMIT_BUTTON_CLICKED = "parents_app_test_page_start_test_submit_test_button_clicked",
    TEST_PAGE_START_TEST_OKAY_BUTTON_CLICKED = "parents_app_test_page_start_test_okay_button_clicked",

  //all simulation clicked
    PARENT_APP_SHOW_ALL_SIMULATIONS_CLICKED = "parent_app_show_all_simulations_clicked",
    PARENT_APP_SIMULATION_LIST_PAGE_ACCESSED = "parent_app_simulation_list_page_accessed",
    PARENT_APP_SIMULATION_PAGE_SIMULATION_CLICKED = "parent_app_simulation_page_simulation_clicked",
    PARENT_APP_SIMULATION_PAGE_FILTER_CLICKED = "parent_app_simulation_page_filter_clicked",
    PARENT_APP_SIMULATION_PAGE_SEARCH_TYPED = "parent_app_simulation_page_search_typed",
    PARENT_APP_ACTIVE_SIMULATION_CLICKED = "parent_app_active_simulation_clicked",
}
